///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { dateFormat, division } from "./types";

const getDeadlineDate = (bid, user, timeZone, expectedFormat) => {
  const zonedDeadlineDate = utcToZonedTime(bid.deadlineDateUTC, timeZone);
  const deadlineDateFormat =
    expectedFormat ||
    (user.division === division.coy
      ? dateFormat.MMddyyyy
      : dateFormat.ddMMyyyy);
  const formattedDeadlineDate = format(zonedDeadlineDate, deadlineDateFormat);

  return formattedDeadlineDate;
};

export default getDeadlineDate;
